import {connect} from "react-redux";
import WarehousesPage from "./WarehousesPage";
import * as inventoryApiActions from "../actions/InventoryApiActions";
import * as selectionActions from "../actions/SelectionActions";
import * as viewActions from "../actions/ViewActions";
import {getSelection} from "../reducers/selectionReducer";
import {getWarehouses, getWarehouseWithId} from "../reducers/inventoryReducer";

function mapStateToProps(state) {
  const context = "warehouses";
  const selection = getSelection(state.get("selection"), context);
  return {
    context: context,
    warehouses: getWarehouses(state.get("inventory")),
    selectedWarehouse: getWarehouseWithId(state.get("inventory"), selection),
    selection: selection
  }
}

export default connect(mapStateToProps, {...inventoryApiActions, ...selectionActions, ...viewActions})(WarehousesPage);